module.exports = __webpack_public_path__ + "2eda721c7803740d15520284ea688470.jpg";